//该文件专门用于创建整个应用的路由器
import VueRouter from "vue-router";
import AboutUs from "@/components/AboutUs.vue";
import ArticleList from "@/components/ArticleList.vue";
import ProductList from "@/components/ProductList.vue";
import ShowProduct from "@/components/ShowProduct.vue";
import ShowArticle from "@/components/ShowArticle.vue";
import ContactUs from "@/components/ContactUs.vue";
//创建一个路由器
export default new VueRouter({
  routes: [
    {
      path: "/",
      component: AboutUs,
    },
    {
      path: "/aboutus",
      component: AboutUs,
    },
    {
      path: "/article",
      component: ArticleList,
    },
    {
      path: "/products",
      component: ProductList,
    },
    {
      path: "/showproduct/:id",
      component: ShowProduct,
    },
    {
      path: "/showarticle/:id",
      component: ShowArticle,
    },
    {
      path: "/contactus",
      component: ContactUs,
    },
  ],
});
